<template>
    <v-card>
        <v-card-title>
            {{title}}
        </v-card-title>
        <v-card-text>
            <v-row v-if="products.length" >
                <v-col>
                    <v-list two-line>
                        <v-list-item v-for="product in products" :key="'_product' + product.id">
                            <v-list-item-content>
                                <v-list-item-title>{{ product.name }}</v-list-item-title>
                                <v-list-item-subtitle>available: {{ product.available }} | pending : {{ product.pending }} | incoming : {{ product.incoming }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn small icon @click="$emit('openAddingProductForm', product)" :disabled="alreadyUsed(product)">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <v-pagination
                        v-if="total > 1"
                        v-model="currentPage"
                        :length="total"
                    ></v-pagination>
                </v-col>
            </v-row>
            <div v-else>
                No products in pending for this supplier
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => 'Supplier\'s products'
        },
        products: {
            type: Array,
            required: true
        },
        total:{
            type: Number,
            default: 0
        },
        page: {
            type: Number,
            default: 1
        },
        lines: {
            type:Array,
            default: () => []
        }
    },
    computed: {
        currentPage : {
            get () {
                return this.page
            },
            set (p) {
                this.$emit('changePage', p)
            }
        },
        alreadyUsed () {
            return (product) => {
                return !!this.lines.filter(l => l.product_id == product.id).length
            }
        }
    },
    methods: {
        
    }
}
</script>